import styled from 'styled-components';
import { Theme } from '@cubeyou-team/hx-theme';
import { getItemInteractionStyle, getIsDragging } from './utils';

export const StyledItemActions = styled.div<{ theme: Theme }>`
  position: absolute;
  right: 0;
  top: 0;
  height: 100%;
  z-index: 1;
  display: none;
  align-items: center;
  background: ${(props) => props.theme.colors.light};
`;

export const StyledSearchResultsItem = styled.div<{
  theme: Theme;
  isDragging?: boolean;
  isDraggable?: boolean;
  disabled?: boolean;
}>`
  align-items: center;
  position: relative;
  padding-left: ${(props) => props.theme.spacing.medium};
  padding-right: ${(props) => props.theme.spacing.medium};
  padding-top: ${(props) => props.theme.spacing.small};
  padding-bottom: ${(props) => props.theme.spacing.small};
  border-radius: ${(props) => props.theme.border_radius.standard};
  background-color: transparent;
  cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};
  opacity: ${(props) => (props.disabled ? 0.5 : 1)};

  button.hx-more-info-button {
    display: none;
  }

  ${(props) => getItemInteractionStyle(props)};
  ${(props) => getIsDragging(props)}

  &:hover {
    button.hx-more-info-button {
      display: ${(props) => (props.disabled ? 'none' : 'block')};
    }
  }

  &:focus {
    outline: none;
  }
`;

export const StyledMoreInfoModal = styled.div<{ theme: Theme }>`
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: ${(props) => props.theme.zindex.medium};
  z-index: 3;
`;

export const StyledQueryEntityDrag = styled.div<{ isDragging?: boolean }>`
  cursor: ${(props) => (!props.isDragging ? 'grab' : 'grabbing')};
`;

export const StyledText = styled.div`
  span {
    line-height: 2px;
  }
`;
